export default {
  header: {
    house: 'Maison',
    activities: 'Activités',
    beaches: 'Plages',
    history: 'Histoire',
    cityGuide: 'Guide de la ville',
    contact: 'Contact',
    phone: '+30 6983446269'
  },
  hero: {
    title: 'Créez votre échappée relaxante en Crète',
    bookNow: 'Réserver maintenant',
    phone: '+30 6983446269',
    airbnb: 'Airbnb',
    booking: 'Booking',
    yourRentals: 'YourRentals'
  },
  house: {
    title: 'Azure Loft',
    description: 'Découvrez Azure Loft, un charmant appartement boho au cœur de la Crète, conçu pour une détente et un confort absolus. Avec une vue imprenable sur la mer, une esthétique boho chaleureuse et toutes les commodités modernes, c\'est le choix idéal pour les couples, les familles ou les amis à la recherche d\'une expérience de séjour unique.',
    features: [
      'Espaces',
      '1 chambre dans une mezzanine en bois traditionnelle avec un lit double confortable',
      'Salle à manger avec canapé-lit, adaptée pour un invité supplémentaire',
      'Salon confortable avec télévision et décoration lumineuse',
      'Balcon avec table et chaises, parfait pour profiter de la vue unique sur la mer',
      'Cuisine & Équipements',
      'Cuisine entièrement équipée avec réfrigérateur, four, plaques de cuisson, cafetière et tous les ustensiles nécessaires',
      'Salle de bain avec douche, équipements sanitaires modernes et eau chaude 24h/24',
      'Commodités & Extras',
      'Climatisation',
      'Lave-linge et fer à repasser',
      'Linge blanc propre (draps, serviettes, oreillers)',
      'Télévision à écran plat',
      'Parking facile à proximité de la propriété'
    ],
    bookNow: 'Réserver maintenant',
    rooms: {
      bedroom: 'Chambre',
      livingRoom: 'Salon',
      bedroom2: 'Chambre 2',
      kitchen: 'Cuisine',
      veranda: 'Véranda'
    },
    viewPhotos: 'Voir les photos',
    closeGallery: 'Fermer'
  },
  reasons: {
    title: 'Les 5 meilleures raisons de séjourner',
    reason1: {
      title: '1. Vues à couper le souffle',
      description: 'Depuis le balcon d\'Azure Loft, vous assisterez à une scène sortie d\'un tableau : la mer crétoise infinie, le port d\'Héraklion en arrière-plan, et les couleurs du coucher de soleil qui peignent le ciel chaque soir. Parfait pour le café du matin et le vin du soir, avec un sentiment unique de tranquillité.'
    },
    reason2: {
      title: '2. La ville... à portée de main',
      description: 'Bien que vous soyez dans un village tranquille, le centre d\'Héraklion n\'est qu\'à 15-20 minutes. Là, vous trouverez tout ce dont vous avez besoin : des musées et attractions au marché animé, restaurants, bars et événements culturels. L\'accès est facile et idéal pour les excursions d\'une journée.'
    },
    reason3: {
      title: '3. Crète authentique',
      description: 'Rodia est l\'un des plus beaux villages traditionnels d\'Héraklion. Construit sur une colline avec vue sur la mer et rempli d\'allées pavées de pierre, petites cours et vieilles maisons, il offre un sentiment d\'authenticité rare. C\'est un endroit où le temps s\'écoule plus lentement – et c\'est son plus grand privilège.'
    },
    reason4: {
      title: '4. Plages aux eaux cristallines',
      description: 'À moins de 20 minutes en voiture d\'Azure Loft, des plages attendent pour chaque préférence. Ammoudara offre organisation et animation, Ligaria est idéale pour les familles avec des eaux propres et calmes, tandis qu\'Agia Pelagia combine beau paysage et bonne nourriture au bord de la mer. Pour des moments plus tranquilles, préférez Made ou le pittoresque Psaromoura, avec des eaux bleu cristal et une atmosphère crétoise authentique.'
    },
    reason5: {
      title: '5. Pour des moments qui durent',
      description: 'Azure Loft est idéal pour ceux qui veulent échapper à l\'ordinaire et vivre quelque chose de plus authentique, humain et paisible. Que vous voyagiez avec votre partenaire, famille ou amis, ici vous ressentirez une vraie relaxation et créerez des souvenirs que vous vous rappellerez avec un sourire.'
    }
  },
  location: {
    title: 'Notre emplacement',
    subtitle: 'Un paradis pittoresque',
    description: 'Azure Loft est situé dans l\'enchantante Rodia d\'Héraklion, un établissement crétois traditionnel construit en amphithéâtre sur une colline, avec des vues panoramiques sur la mer crétoise et la ville d\'Héraklion. Rodia combine hospitalité authentique avec beauté naturelle unique, tout en servant de point de départ idéal pour explorer à la fois l\'arrière-pays et la côte nord de l\'île.\n\nÀ proximité, vous pouvez découvrir des eaux cristallines, comme Palaikastro, Ammoudara, et le port de Ligaria, idéales pour la baignade, le bronzage et les activités aquatiques.\n\nLes passionnés d\'histoire et de culture peuvent facilement visiter le Musée archéologique d\'Héraklion (18 km), les murs vénitiens (17 km), ainsi que le célèbre palais de Knossos (21 km). Pour une excursion familiale, Cretaquarium – Thalassokosmos n\'est qu\'à 33 km et offre une expérience inoubliable pour jeunes et moins jeunes.\n\nL\'emplacement d\'Azure Loft assure un accès facile à l\'aéroport international d\'Héraklion (20 km), tandis que l\'hébergement dispose également d\'un parking privé gratuit, offrant commodité pour vos déplacements.\n\nDécouvrez le charme de la Crète authentique, avec la mer en arrière-plan et la tranquillité du paysage semi-montagneux de Rodia.'
  },
  calendar: {
    title: 'Disponibilité Azure Loft',
    close: 'Fermer',
    bookAirbnb: 'Réserver sur Airbnb',
    bookBooking: 'Réserver sur Booking',
    bookYourRentals: 'Réserver sur YourRentals',
    requestQuote: 'Demander un devis'
  },
  footer: {
    generalInfo: 'Informations générales',
    location: 'Emplacement',
    getDirections: 'Obtenir l\'itinéraire',
    contactWays: 'Moyens de contact',
    faq: 'Questions fréquemment posées',
    usefulLinks: 'Liens utiles',
    carRental: 'Location de voiture',
    busRoutes: 'Itinéraires de bus',
    cityGuide: 'Guide de la ville',
    socialMedia: 'Réseaux sociaux',
    newsletter: 'Newsletter',
    emailPlaceholder: 'Votre email',
    signUp: 'Inscrivez-moi !',
    copyright: 'Copyright © AZURE LOFT GREECE 2025',
    manual: 'Manuel de la maison'
  },
  reviews: [
    {
      author: 'Gerasimos',
      date: 'il y a 5 mois',
      rating: 5,
      text: 'Nous avons eu une excellente expérience pendant notre séjour dans la maison de location ! L\'hébergement était impeccable, entièrement équipé et très confortable. Son emplacement était idéal, près de tout ce dont nous avions besoin, mais en même temps assez calme pour profiter de notre tranquillité. Le propriétaire était extrêmement amical et serviable, toujours disponible pour nous aider avec toute question ou besoin qui surgissait. Il nous a aussi donné des conseils utiles sur la région, comme des endroits pour manger et des activités. La maison avait une décoration moderne, des lits confortables et tout ce dont nous avions besoin pour nous sentir chez nous. Le Wi-Fi était rapide et fiable, ce que nous avons particulièrement apprécié. Dans l\'ensemble, une expérience fantastique que je recommanderais définitivement à quiconque cherche un hébergement de qualité. Nous avons hâte de revenir !'
    },
    {
      author: 'Ioannis Papadakis',
      date: 'il y a 5 mois',
      rating: 5,
      text: 'Vraiment une belle maison chaleureuse avec des vues incroyables. Nous avons séjourné à Héraklion pour une courte période car notre destination était au sud de Réthymnon. La première chose qui a attiré notre attention était la vue quand nous avons fait la réservation et c\'est vraiment incroyable. Aussi la maison est très propre et sentait bon ce qui est très agréable quand vous entrez pour la première fois dans la villa.'
    },
    {
      author: 'Panagiotis Chandroulidis',
      date: 'il y a 1 mois',
      rating: 5,
      text: 'C\'est merveilleux avec de belles vues. Le propriétaire est hospitalier et très gentil. Je vous recommande de le choisir, je suis sûr que vous apprécierez votre séjour.'
    },
    {
      author: 'Vasilis',
      date: '2 mars 2025',
      rating: 5,
      text: 'La maison était très belle et idéale pour les escapades romantiques. Entièrement équipée et nous pouvions cuisiner😊 La vue la nuit était fantastique depuis la maison avec un verre de vin c\'était quelque chose d\'autre. L\'hôtesse nous a envoyé des instructions détaillées pour la maison. Assez amicale. Très bonne impression dans l\'ensemble.',
      source: 'booking'
    },
    {
      author: 'Sevi Kallergi',
      date: 'il y a 23 semaines',
      rating: 5,
      text: 'Vues magiques et espace confortable. C\'était propre et tout était parfait ! Calme et relaxant. J\'y retournerai définitivement !'
    },
    {
      author: 'alex tevre',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'En visitant la Crète fréquemment, je peux honnêtement dire que c\'était l\'un des meilleurs appartements où j\'ai jamais séjourné ! L\'incroyable...'
    },
    {
      author: 'Eirini Vrentzou',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Vraiment merveilleux.... Je n\'ai pas de mots pour décrire la beauté..tout était parfait et bien entretenu...je le recommande sans réserve...'
    },
    {
      author: 'Antonis Aerakis',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Tout était parfait ! Espace merveilleux et propre avec des vues incroyables !'
    },
    {
      author: 'Konstantina Orfanou',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Très bel espace et les hôtes sont amicaux, serviables et prêts à aider....'
    },
    {
      author: 'Penny Stathogiannopoulou',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Espace merveilleux avec une esthétique très belle. Impeccable et bien entretenu jusqu\'au dernier détail ! Mon endroit préféré...'
    },
    {
      author: 'MARIA IOANNA RESTIVAKI',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Si vous cherchez une escapade paisible et pittoresque, cette maison de vacances à Rodia est un excellent choix !...'
    },
    {
      author: 'Maria Stavroulaki',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Très bel espace et combiné avec la vue incroyable d\'Héraklion a rendu notre séjour inoubliable !!'
    },
    {
      author: 'vasilis maris',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Je vous donne mes félicitations pour la beauté et la rénovation de votre maison. Notre séjour était merveilleux et le...'
    },
    {
      author: 'Manos Papadakis',
      date: 'il y a 24 semaines',
      rating: 5,
      text: 'Très belles vues, le locataire très serviable et tout problème que j\'avais était résolu immédiatement je le recommande sans réserve pour vos vacances que ce soit été ou hiver 😁'
    },
    {
      author: 'Panagiotis',
      date: '25 juin 2025',
      rating: 5,
      text: 'Le propriétaire et le gestionnaire sont des gens merveilleux, hospitaliers et gentils. Nous avons eu un séjour parfait et une merveilleuse collaboration. La maison était propre et à notre arrivée nous avons été accueillis avec une belle surprise. Mais le point fort est le balcon, la vue est belle, vous pouvez voir tout Héraklion et l\'infini bleu de la mer.',
      source: 'booking'
    },
    {
      author: 'Lise',
      date: 'Mai 2025',
      rating: 3,
      text: 'Bon emplacement pour visiter la région d\'Héraklion et près de l\'aéroport. Petit hébergement pour 4 personnes (y compris les enfants, escalier en colimaçon). Certaines améliorations sont nécessaires...',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'Avril 2025',
      rating: 5,
      text: 'Endroit calme avec de belles vues. La communication était excellente.',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'Mars 2025',
      rating: 5,
      text: 'La maison était très propre et la vue depuis le balcon était incroyable et vous aviez toutes les commodités et l\'hôte était très amical et m\'a aidé avec tout problème que j\'avais',
      source: 'airbnb'
    }
  ],
  reviewsSection: {
    subtitle: 'Ce que disent nos visiteurs !',
    title: 'Avis'
  },
  contact: {
    title: 'Contactez-nous',
    phone: 'TÉLÉPHONE',
    email: 'EMAIL',
    namePlaceholder: 'Entrez votre nom',
    emailPlaceholder: 'Entrez une adresse email valide',
    messagePlaceholder: 'Votre message',
    submit: 'ENVOYER',
    sending: 'Envoi...',
    success: 'Votre message a été envoyé avec succès !',
    error: 'Une erreur s\'est produite. Veuillez réessayer.'
  },
  readMore: 'Lire la suite',
  readLess: 'Lire moins'
}; 